<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container">
      <div class="page-heading d-flex align-items-center">
        <img
          src="../../assets/bckarrow.svg"
          class="pointer"
          alt=""
          @click="gotodashboard"
        />
        <div class="main-head ml-4">
          <span>Shortlisted Candidates</span>
        </div>
      </div>
      <div class="slectedcandidate-table-container relativeclass mt-3">
        <div class="d-flex align-items-center justify-content-between">
          <div class="search-bar mr-3">
            <img
              class="searchicon"
              src="../../assets/img/search-bar-icon.svg"
              alt=""
            />
            <b-form-input
              type="search"
              class="search-input"
              v-model.trim="searchQuery"
              placeholder="Search candidate name here"
              @keyup="textSearch()"
            ></b-form-input>
          </div>
        </div>

        <!-- table starts -->
        <div class="table-main mt-3">
          <table
            class="w-100 table-design selected-dash-table"
            :aria-describedby="'Candidate detais'"
          >
            <thead>
              <tr>
                <th class="text-center" style="width: 20%">
                  <span class="pl-2">Candidate Name</span>
                  <template v-if="statusValue == 'customerName'">
                    <img
                      v-if="!sortByValue && filter"
                      class="pointer"
                      @click="
                        (sortByValue = !sortByValue),
                          (statusValue = 'customerName'),
                          (order = 1);
                        getselectedCandidate();
                      "
                      src="../../assets/img/candidatedashboard/upfilter.svg"
                      alt=""
                    />
                    <img
                      v-if="sortByValue && filter"
                      class="pointer"
                      @click="
                        (sortByValue = !sortByValue),
                          (statusValue = 'customerName'),
                          (order = -1);
                        getselectedCandidate();
                      "
                      src="../../assets/img/candidatedashboard/downfilter.svg"
                      alt=""
                    />
                  </template>
                  <img
                    class="pointer"
                    v-else
                    @click="
                      (filter = true),
                        (statusValue = 'customerName'),
                        (sortByValue = true),
                        (order = 1),
                        getselectedCandidate()
                    "
                    src="../../assets/img/candidatedashboard/nofilter.svg"
                    alt=""
                  />
                </th>
                <th class="text-center" style="width: 20%">
                  <span>Email</span>
                </th>
                <th class="text-center" style="width: 10%">
                  <span>Phone Number</span>
                </th>
                <th class="text-center" style="width: 10%">
                  <span>Current CTC</span>
                </th>
                <th class="text-center" style="width: 10%">
                  <span>Expected CTC</span>
                </th>
                <th class="text-center" style="width: 5%">Gender</th>
                <th class="text-center" style="width: 10%">
                  <span>Highest Qualification</span>
                </th>
                <th class="text-center" style="width: 15%">Action</th>
              </tr>
            </thead>

            <tbody v-if="selectedcandidate.length > 0">
              <tr
                class="selected-table-cards"
                v-for="cand in selectedcandidate"
                :key="cand.candidateID"
              >
                <td class="relativeclass text-center" style="width: 20%">
                  <div
                    :style="{
                      background: '#' + Math.random().toString(16).slice(-6),
                    }"
                    class="gridgreencolorDynamic mr-1"
                  ></div>
                  <span class="pl-3">{{ cand.name }} </span>
                </td>
                <td class="text-center" style="width: 20%">{{ cand.email }}</td>
                <td class="text-center" style="width: 10%">
                  {{ cand.phoneNumber }}
                </td>
                <td class="text-center" style="width: 10%">
                  {{ cand.currentCTC }}
                </td>
                <td class="text-center" style="width: 10%">
                  {{ cand.expectedCTC }}
                </td>
                <td class="text-center" style="width: 5%">
                  <span class="ml-2">
                    {{ cand.gender }}
                  </span>
                </td>
                <td class="text-center" style="width: 10%">
                  {{ cand.highestQualification }}
                </td>

                <td class="text-center" style="width: 15%">
                  <div class="hrtable-status" @click="gotoOfferletter(cand)">
                    Generate OfferLetter
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="text-center">No Candidates</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- table ends -->
        <div
          class="paginaTion d-flex justify-content-between align-items-center"
        >
          <div class="d-flex">
            <span class="qb-gotopage-text p-1">Go to page</span>
            <b-form-input
              type="text"
              class="qb-pagination-num mr-1"
              v-model="goToPage"
              @keyup.enter="
                goToPage === null || goToPage == '' || iscontainsNumber
                  ? ''
                  : gotopgnum(goToPage)
              "
            ></b-form-input>
            <b-button
              class="qb-pagination-addbtn"
              @click="gotopgnum(goToPage)"
              :disabled="
                goToPage === null || goToPage == '' || iscontainsNumber
              "
            >
              <span><img src="../../assets/whiterightarrow.svg" alt="" /></span>
            </b-button>
          </div>
          <div class="pagination">
            <b-pagination
              v-model="page"
              @input="getselectedCandidate()"
              :total-rows="total"
              :per-page="count"
              align="center"
              first-number
              last-number
            >
              <template #prev-text
                ><span><img src="../../assets/leftvector.svg" alt="" /> </span
              ></template>
              <template #next-text
                ><span><img src="../../assets/rightarrow.svg" alt="" /></span
              ></template>
            </b-pagination>
          </div>
          <div class="qb-gotopage-text mr-2">
            Results : <span v-if="pageStart > total">0</span
            ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
            <span class="pl-1"></span> of <span class="pr-1"></span>{{ total }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getselectedcandPagination } from "../../utils/apiFunctions.js";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
export default {
  name: "SelectedCandidates",
  components: {
    Spinner,
  },
  data() {
    return {
      //NUMBER
      totalPages: null,
      count: 50,
      page: 1,
      goToPage: null,
      total: null,
      pageStart: null,
      pageEnd: null,
      timer: null,

      //STRINGS
      candidateID: "",
      searchQuery: "",
      statusValue: "",
      sortBy: "updatedAt",
      order: "-1",

      //BOOLEAN
      LoaderStatus: false,
      disable: true,
      filter: false,
      sortByValue: false,

      // OBJECTS

      //ARRAYS
      selectedcandidate: [],
    };
  },
  computed: {
    iscontainsNumber() {
      return !/^[1-9]\d*$/.test(this.goToPage);
    },
  },

  created() {
    this.getselectedCandidate();
  },
  methods: {
    // search function
    textSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.page = 1;
        this.getselectedCandidate();
      }, 400);
    },

    // Go to selected Page
    gotopgnum(index) {
      if (index > 0) {
        this.page = Math.min(Math.max(1, index), this.totalPages);
        this.getselectedCandidate();
      }
      this.goToPage = null;
    },
    // GET ALL CANDIDATES
    async getselectedCandidate() {
      try {
        let payload = {
          sortBy: this.sortBy,
          order: this.order,
          count: this.count,
          actionList: this.actionList,
          searchQuery: this.searchQuery,
          page: this.page - 1,
        };
        const res = await getselectedcandPagination(payload);
        if (res.status == 200) {
          this.selectedcandidate = res.data.data.data;
          this.total = res.data.data.total;
          this.pageStart = res.data.data.pageStart;
          this.pageEnd = res.data.data.pageEnd;
          this.totalPages = Math.ceil(
            parseInt(this.total) / parseInt(this.count)
          );
        }
      } catch (error) {
        throw new Error(
          `Failed! getting getselectedCandidate ! status: ${error.status}`
        );
      }
    },

    gotoOfferletter(cand) {
      this.$store.commit("hrPortalReferenceVUEX/saveSelectCandidate", {});
      this.$router.push({
        name: "OfferLetter",
        params: { candidateID: cand.candidateID },
        query: {
          redirect: "SelectedCandidates",
        },
      });
    },
    gotodashboard() {
      this.$router.push({
        name: "Dashboard",
      });
    },
  },
};
</script>

<style>
.gridgreencolorDynamic {
  width: 4px;
  height: 45px;
  border-radius: 2px;
  position: absolute;
  left: 0px;
  top: 2px;
  background: #00bad9;
}
.selected-table-cards:hover {
  background: #e7e8f5;
}
</style>
